import { styled } from '@mui/material/styles';
import LinkButton from 'src/components/LinkButton/LinkButton';
import { spreadTypography } from '../../../../utils/typeUtils';
export const Link = styled(LinkButton)(({
  theme
}) => ({
  ...spreadTypography(theme.typography['Lato Link 1']),
  [theme.breakpoints.down('sm')]: {
    ...spreadTypography(theme.typography['Lato Link 2'])
  }
}));